export default "__VITE_ASSET__5c824a7f__"